<tt-page>
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-list [ttData]="items" ttBackStyle [ttGoto]="false" [ttClickable]="canSelect" (ttClick)="select($event.item)"></tt-list>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="selectoeestateremark_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <tt-list [ttData]="items" ttBackStyle [ttGoto]="false" [ttClickable]="canSelect" (ttClick)="select($event.item)"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-container>
</tt-page>

<p *ngIf="error" role="alert">{{ error }}</p>
